<!--工单变更报表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          v-decorator="['desOrganizationCode']"
          :allow-clear="false"
          :default-active-first-option="defaultSelect"
          slot="desOrganizationCode"
          :dropdown-match-select-width="false"
          :value.sync="queryParams.desOrganizationCode"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
        <global-select
          slot="responsibleParty"
          :value.sync="queryParams.responsibleParty"
          :selectData="changeLiabilityList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
        <global-select
          slot="activePassiveName"
          :value.sync="queryParams.activePassiveName"
          :selectData="updateMethodList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupValue', label: 'lookupValue' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiAssessmentDeliveryDateChangesExport" ref="download" />
        <a-button type="primary" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
        >
          <!--考核交期-零部件和成品区别展示, 成品不用展示时分秒-->
          <template slot="assessmentDeliveryDateForm" slot-scope="{ text, record }">
            <span v-if="record.wipEntityFlag==='FINISHED_PRODUCT_JOB'">{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
            <span v-else>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
// import moment from 'moment'
import cacheSearch from '@/mixins/cacheSearch'
import { apiGetAssessmentDeliveryDateChanges, apiAssessmentDeliveryDateChangesExport } from '@/api/report/work-order-change-report'
import cacheRequest from '@/mixins/cacheRequest'

export default {
  name: 'WorkOrderChange',
  components: { DownloadModal },
  mixins: [cacheSearch, cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data () {
    return {
      apiAssessmentDeliveryDateChangesExport,
      changeLiabilityList: [], // 变更责任方
      updateMethodList: [], // 是否主动变更
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetAssessmentDeliveryDateChanges, true),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        desOrganizationCode: undefined,
        changeInitiatorDate: undefined,
        changeInitiatorDateStart: undefined,
        changeInitiatorDateEnd: undefined,
        newAssessmentDeliveryDate: undefined,
        newAssessmentDeliveryDateStart: undefined,
        newAssessmentDeliveryDateEnd: undefined,
        assessmentDelivery: undefined,
        assessmentDeliveryDateStart: undefined,
        assessmentDeliveryDateEnd: undefined,
        responsibleParty: undefined,
        activePassiveName: undefined,
        orderNo: undefined,
        wipEntityName: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        { label: '工厂', decorator: ['desOrganizationCode'], type: 'desOrganizationCode' },
        {
          label: '发起变更日期',
          type: 'range',
          decorator: ['changeInitiatorDate'],
          disposeFormat: {
            changeInitiatorDateStart: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            changeInitiatorDateEnd: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        {
          label: '变更后考核交期',
          type: 'range',
          decorator: ['newAssessmentDeliveryDate'],
          disposeFormat: {
            newAssessmentDeliveryDateStart: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            newAssessmentDeliveryDateEnd: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        {
          label: '变更前考核交期',
          type: 'range',
          decorator: ['assessmentDelivery'],
          disposeFormat: {
            assessmentDeliveryDateStart: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            assessmentDeliveryDateEnd: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        { label: '变更责任方', decorator: ['responsibleParty'], type: 'responsibleParty' },
        { label: '主/被动变更', decorator: ['activePassiveName'], type: 'activePassiveName' },
        { label: '计划单号', decorator: ['orderNo'], type: 'input' },
        { label: '工单号', decorator: ['wipEntityName'], type: 'input' },
        { label: '流程编号', decorator: ['billNo'], type: 'input' }
      ],
      // 表格字段
      columns: [
        { title: '流程编号', dataIndex: 'billNo', align: 'center', width: 110 },
        { title: '是否主动变更', dataIndex: 'activePassiveName', align: 'center', width: 110 },
        { title: '变更类型', dataIndex: 'changeTypeName', align: 'center', width: 100 },
        { title: '交期变更套数', width: 100, dataIndex: 'assessmentChangeQuantity', align: 'center' },
        { title: '变更原因', dataIndex: 'changeReason', align: 'center', width: 140, ellipsis: true },
        { title: '变更发起方', dataIndex: 'changeInitiator', align: 'center', width: 120 },
        { title: '变更责任方', dataIndex: 'responsiblePartyName', align: 'center', width: 120 },
        { title: '变更前交期', dataIndex: 'assessmentDeliveryDate', scopedSlots: { customRender: 'assessmentDeliveryDateForm' }, align: 'center', width: 160 },
        { title: '变更后交期', dataIndex: 'newAssessmentDeliveryDate', scopedSlots: { customRender: 'assessmentDeliveryDateForm' }, align: 'center', width: 160 },
        { title: '备注', dataIndex: 'remark', align: 'center', width: 140, ellipsis: true },
        { title: '加工组织', dataIndex: 'desOrganizationName', align: 'center', width: 140 },
        { title: '工单号', dataIndex: 'wipEntityName', align: 'center', width: 140 },
        { title: '计划单号', dataIndex: 'orderNo', align: 'center', width: 140 },
        { title: '工单状态', dataIndex: 'statusName', align: 'center', width: 100 },
        { title: '审批状态', dataIndex: 'approvalStatusName', align: 'center', width: 100 },
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 140 },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 140 },
        { title: '规格描述', dataIndex: 'specification', align: 'center', width: 150, ellipsis: true },
        { title: '单位', dataIndex: 'primaryUom', align: 'center', width: 90 },
        { title: '计划数量', dataIndex: 'planQuantity', align: 'center', width: 100 },
        { title: '发起变更日期', dataIndex: 'changeInitiatorDate', align: 'center', width: 160 }
      ]
    }
  },
  created () {
    if (this.cacheHistory && this.cacheHistory[this.$route?.fullPath]) {
      // 处理缓存逻辑
      this.getHistoryCache(
        'refSearchForm',
        'desOrganizationCode',
        {
          changeInitiatorDate: ['changeInitiatorDateStart', 'changeInitiatorDateEnd'],
          newAssessmentDeliveryDate: ['newAssessmentDeliveryDateStart', 'newAssessmentDeliveryDateEnd'],
          assessmentDelivery: ['assessmentDeliveryDateStart', 'assessmentDeliveryDateEnd']
        }
      )
    }
    this.cacheLookupRequest('MES_ASSESSMENT_DELIVERY_DATE_UPDATE_METHOD', { lookupType: 'MES_ASSESSMENT_DELIVERY_DATE_UPDATE_METHOD', current: 1, pageSize: 999 }, 'updateMethodList')
    this.cacheLookupRequest('MES_JOB_CHANGE_LIABILITY', { lookupType: 'MES_JOB_CHANGE_LIABILITY', current: 1, pageSize: 999 }, 'changeLiabilityList')
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch (value = {}) {
      const params = {
        ...this.queryParams,
        ...value
      }
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    // 重置按钮操作
    resetQuery () {
      this.queryParams = {
        desOrganizationCode: undefined,
        changeInitiatorDate: undefined,
        changeInitiatorDateStart: undefined,
        changeInitiatorDateEnd: undefined,
        newAssessmentDeliveryDate: undefined,
        newAssessmentDeliveryDateStart: undefined,
        newAssessmentDeliveryDateEnd: undefined,
        assessmentDelivery: undefined,
        assessmentDeliveryDateStart: undefined,
        assessmentDeliveryDateEnd: undefined,
        responsibleParty: undefined,
        activePassiveName: undefined,
        orderNo: undefined,
        wipEntityName: undefined
      }
    },
    // 导出
    handleExport () {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
